import PropTypes from 'prop-types';
import Portal from 'react-portal';

const fixedStyle = {
  position: 'fixed',
};

export default function FixedInIFrame({
  children,
  className,
  style,
  dataHook,
}) {
  return (
    <Portal isOpened role="presentation">
      <div
        style={_.assign({}, style, fixedStyle)}
        data-hook={dataHook}
        className={className}
        role="presentation"
      >
        {children}
      </div>
    </Portal>
  );
}

FixedInIFrame.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  dataHook: PropTypes.string,
  style: PropTypes.object,
};
